jQuery(document).ready(function ($) {
 /*  var rellax = new Rellax('.rellax', {
    speed: 4,
    center: false,
    wrapper: null,
    round: true,
    vertical: true,
    horizontal: false
  }); */
});